<template>
  <div class="push-container">
    <div class="container-title">
      <span>{{ $route.name }}</span>
    </div>
    <el-form
      ref="alarm_push_form"
      :v-model="form_data"
      label-width="110px"
      style="padding: 70px 30px 70px 30px"
    >
      <el-form-item style="white-space: nowrap">
        <div
          v-for="one in form_data"
          style="display: inline; padding-right: 20px"
        >
          {{ one.name }}
          <el-switch
            @change="changePushStatus(one.id, one.state)"
            v-model="one.state"
          ></el-switch>
        </div>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 10px">
      <label
        style="
          width: 80px;
          text-align: right;
          vertical-align: middle;
          font-size: 14px;
          color: grey;
          line-height: 1;
          padding: 10px 10px 10px 10px;
          box-sizing: border-box;
        "
        >项目:</label
      >
      <el-input
        placeholder="请选择项目"
        suffix-icon="el-icon-date"
        style="width: 140px"
        @focus="showProjectTree"
        v-model="projectNames"
      ></el-input>
      <el-dialog title="项目归属" v-model="projectTreeDialogVisible">
        <div style="">
          <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText"
          ></el-input>
          <el-tree
            class="filter-tree"
            :data="projectTree"
            show-checkbox
            node-key="id"
            :default-checked-keys="projectTreeDefaultChecked"
            :filter-node-method="filterNode"
            ref="projectTree"
          ></el-tree>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="projectTreeOnCancel">取 消</el-button>
          <el-button type="primary" @click="projectTreeOnSubmit"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <el-button @click="handleAdd">新增告警</el-button>
    </el-col>
    <el-table
      :data="list_data"
      highlight-current-row
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
    >
      <el-table-column type="index" width="50"> </el-table-column>
      <el-table-column prop="projectName" label="归属项目" width="100" sortable>
      </el-table-column>
      <el-table-column prop="name" label="告警名称" width="120" sortable>
      </el-table-column>
      <el-table-column prop="webhook" label="webhook地址" width="420" sortable>
      </el-table-column>
      <el-table-column
        prop="accountNames"
        label="钉钉告警联系人"
        width="320"
        sortable
      >
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="small"
            @click="handleDeleteOne(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="15"
        :total="total"
        style="float: right"
      >
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="所属项目" prop="projectId">
          <div>
            <el-select
              v-model="editForm.projectId"
              @change="selectProjectChange('edit',editForm.projectId)"
              filterable
			  placeholder="请选择"
              style="width: 300px"
            >
              <el-option
                v-for="item in projectList"
                v-bind:key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item prop="name" label="告警名称">
          <el-input v-model="editForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="钉钉告警类型" prop="" class="el-badge item">
          <div style="display: inline; padding-right: 4px">报警:
		  </div>
          <el-switch v-model="editForm.smsAlarmEnable"></el-switch>
          <div style="display: inline; padding-right: 4px; padding-left: 10px">
            预警:
          </div>
          <el-switch v-model="editForm.smsEarlyAlarmEnable"></el-switch>
          <div style="display: inline; padding-right: 4px; padding-left: 10px">
            离线告警:
          </div>
          <el-switch v-model="editForm.smsOfflineAlarmEnable"></el-switch>
          <!-- <div style="display: inline; padding-right: 4px; padding-left: 10px">
            低电告警:
          </div>
          <el-switch v-model="editForm.smsLowPowerAlarmEnable"></el-switch> -->
        </el-form-item>
		<div  style="margin-top: -15px;margin-left: 120px;margin-bottom: 25px;">
			<label style="color:red;">提示：只有选中的告警类型才会发送钉钉告警</label>
		</div>
        <el-form-item prop="webhook" label="webhook地址">
          <el-input
            type="textarea"
            placeholder="请复制机器人webhook地址到框中,测试成功后保存"
            v-model="editForm.webhook"
            auto-complete="off"
          ></el-input>
          <div
            v-if="editForm.webhookIsValid == false"
            class="status-message error"
          >
            发送失败
          </div>
          <div
            v-if="editForm.webhookIsValid == true"
            class="status-message success"
          >
            发送成功
          </div>
          <el-button
            size="small"
            @click="checkWebhookIsValid(editForm.webhook, 2)"
            >点击测试</el-button
          >
        </el-form-item>
        <el-form-item prop="contactorIds" label="钉钉告警联系人">
		   <treeselect :options ="alarmContactorList" :load-root-options="loadRootOptions"  :treeMark="treeMark" :auto-load-root-options="true"  :multiple="true" 
                          style="width:240px;" placeholder="请选择联系人" noOptionsText="暂无告警联系人,请确认是否选择项目" v-model="editForm.contactorIds" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          v-bind:disabled="editSubmitButtonDisabled"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增告警"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      @close="cancelAddSubmit"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="所属项目" prop="projectId">
          <div>
            <el-select
              v-model="addForm.projectId"
              @change="selectProjectChange('add',addForm.projectId)"
              filterable
              placeholder="请选择"
              style="width: 300px"
            >
              <el-option
                v-for="item in projectList"
                v-bind:key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>

        <el-form-item prop="name" label="告警名称">
          <el-input v-model="addForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="钉钉告警类型" prop="">
          <div style="display: inline; padding-right: 4px">报警:</div>
          <el-switch v-model="addForm.smsAlarmEnable"></el-switch>
          <div style="display: inline; padding-right: 4px; padding-left: 10px">
            预警:
          </div>
          <el-switch v-model="addForm.smsEarlyAlarmEnable"></el-switch>
          <div style="display: inline; padding-right: 4px; padding-left: 10px">
            离线告警:
          </div>
          <el-switch v-model="addForm.smsOfflineAlarmEnable"></el-switch>
          <!-- <div style="display: inline; padding-right: 4px; padding-left: 10px">
            低电告警:
          </div>
          <el-switch v-model="addForm.smsLowPowerAlarmEnable"></el-switch> -->
        </el-form-item>
		<div  style="margin-top: -15px;margin-left: 120px;margin-bottom: 25px;">
			<label style="color:red;">提示：只有选中的告警类型才会发送钉钉告警</label>
		</div>
        <el-form-item prop="webhook" label="webhook地址">
          <el-input
            type="textarea"
            placeholder="请复制机器人webhook地址到框中,测试成功后保存"
            v-model="addForm.webhook"
            auto-complete="off"
          ></el-input>
          <div
            v-if="addForm.webhookIsValid == false"
            class="status-message error"
          >
            发送失败
          </div>
          <div
            v-if="addForm.webhookIsValid == true"
            class="status-message success"
          >
            发送成功
          </div>
          <el-button
            size="small"
            @click="checkWebhookIsValid(addForm.webhook, 1)"
            >点击测试</el-button
          >
        </el-form-item>
        <el-form-item prop="contactorIds" label="钉钉告警联系人">
		  <treeselect :load-root-options="loadRootOptions"  :treeMark="treeMark" :auto-load-root-options="false" :multiple="true" 
                          style="width:240px;" placeholder="请选择联系人" noOptionsText="暂无告警联系人,请确认是否选择项目" v-model="addForm.contactorIds" />
        </el-form-item>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="cancelAddSubmit">取消</el-button>
        <el-button
          type="primary"
          v-bind:disabled="addSubmitButtonDisabled"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import tools from "@/util/tools";
import global from "@/config/global_config";
import Vue from "vue";
import Treeselect from "@riophae/vue-treeselect";
export default {
  components: { Treeselect },
  data() {
    return {
      logining: false,
      form_data: {},
      projectTree: [],
      projectTreeDefaultChecked: [],
      filterText: "",
      projectTreeDialogVisible: false,
      projectTreeCheckedKeys: [],
      projectIds: "",
      projectsOpt: [],
      projectNames: "",
      userRoleIdentity: global.getCurrentUser().roleIdentity,
      listLoading: false,
      list_data: [],
      total: 0,
      page: 1,
      addSubmitButtonDisabled: false,
      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        name: [
          { required: true, message: "请输入告警名称", trigger: "blur" },
          { min: 1, max: 32, message: "输入长度在1到20个字符之间" },
        ],
      },
      addForm: {
        name: "",
      },
      projectList: [],
      alarmContactorList:null,
      editSubmitButtonDisabled: false,
      editFormVisible: false,
      editLoading: false,
      editFormRules: {
        name: [
          { required: true, message: "请输入告警名称", trigger: "blur" },
          { min: 1, max: 32, message: "输入长度在1到20个字符之间" },
        ],
      },
      editForm: {
        name: "",
      },
	  treeMark:"one",
    };
  },
  watch: {
    filterText(val) {
      this.$refs.projectTree.filter(val);
    },
  },
  methods: {
    fetchPushModel: function (index, row) {
      let param = {};
      this.listLoading = true;
	  let self = this;
      api
        .pushManage_fetchPushModel_request(param)
        .then((res) => {
          for (let index = 0; index < res.data.length; index++) {
            if (res.data[index].state == 0) res.data[index].state = false;
            else res.data[index].state = true;
          }
          this.form_data = res.data;
		  this.listLoading = false;
        })
        .catch((e) => {
          console.log(e);
		  self.listLoading = false;
          tools.error(new Vue(), e.message);
        });
    },
    changePushStatus: function (pushid, status) {
      let param = {
        id: pushid,
        state: Number(status),
      };
      this.listLoading = true;
	   let self = this;
      api
        .pushManage_setPushModel_request(param)
        .then((res) => {
          tools.success(this, "设置成功");
          for (let index = 0; index < res.data.length; index++) {
            if (res.data[index].state == 0) res.data[index].state = false;
            else res.data[index].state = true;
          }
          this.form_data = res.data;
		  this.listLoading = false;
        })
        .catch((e) => {
          console.log(e);
		  self.listLoading = false;
          tools.error(new Vue(), e.message);
        });
    },
    get_list_data() {
      let param = {
        projectIds: this.projectIds,
        pageNum: this.page,
        pageSize: 15,
      };
      this.listLoading = true;
	  let self = this;
      api
        .acquireData_findPageWebhookSmsAlarmConfig_request(param)
        .then((res) => {
          this.total = res.data.total;
		  //accountNames
		  res.data.list.forEach(one => {
			let temp = [];
			one.contactorList.forEach(item => {
				temp.push(item.userNameCn);
			});
			if(temp.length>=1)one.accountNames = temp.join(',');
		  })
          this.list_data = res.data.list;
          this.listLoading = false;
        })
        .catch((e) => {
          console.log(e);
          self.listLoading = false;
          tools.error(new Vue(), e.message);
        });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.get_list_data();
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    showProjectTree() {
      this.projectTreeDialogVisible = true;
      return;
    },
    getProjectTree: function () {
      let param = {};
      this.listLoading = true;
	  let self = this;
      api
        .project_findByAccountIdList_request(param)
        .then((res) => {
          let temp = [];
          this.projectList = [];
          if (res.data) {
            for (let index = 0; index < res.data.length; index++) {
              temp[index] = {
                id: -res.data[index].groupId,
                label: res.data[index].groupName,
                children: [],
              };
              res.data[index].projectList.forEach((one) => {
                temp[index].children.push({
                  id: parseFloat(one.projectId),
                  label: one.projectName,
                });
                this.projectList.push({
                  id: one.projectId,
                  name: one.projectName,
                });
              });
            }
          }
          this.projectTree = temp;
        })
        .catch(function (e) {
          console.log(e);
		  self.listLoading = false;
		  
        });
      this.listLoading = false;
    },
    projectTreeOnCancel() {
      this.$refs.projectTree.setCheckedNodes([]);
      this.projectTreeDialogVisible = false;
    },
    projectTreeOnSubmit() {
      let leafCheckedNodes = [];
      let leafCheckedNodeNames = [];
      let checkedNodes = this.$refs.projectTree.getCheckedNodes();
      if (checkedNodes) {
        checkedNodes.forEach((one) => {
          if (!one.children) {
            leafCheckedNodes.push(one.id);
            leafCheckedNodeNames.push(one.label);
          }
        });
        this.projectNames = leafCheckedNodeNames.join(",");
        this.projectIds = leafCheckedNodes.join(",");
      }
      this.projectTreeDialogVisible = false;
      this.get_list_data();
    },
    handleAdd() {
	  this.alarmContactorList = null;
      this.addFormVisible = true;
    },
    cancelAddSubmit() {
      this.addFormVisible = false;
      this.$refs.addForm.resetFields();
      if (this.addSubmitButtonDisabled) this.addSubmitButtonDisabled = false;
    },
    handleDeleteOne: function (index, row) {
      this.$confirm("确认删除该记录吗?", "提示", { showClose: false })
        .then(() => {
          let param = { id: row.id };
          api
            .acquireData_deleteWebhookSmsAlarmConfig_request(param)
            .then((res) => {
              tools.success(this, "删除成功");
              this.get_list_data();
            });
        })
        .catch((e) => {
          console.log(e);
          if (e.message) tools.error(new Vue(), e.message);
        });
    },
    handleEdit: function (index, row) {
      this.editForm = Object.assign({}, row);
      this.editForm.smsAlarmEnable = row.smsAlarmEnable == 1 ? true : false;
      this.editForm.smsEarlyAlarmEnable =
        row.smsEarlyAlarmEnable == 1 ? true : false;
      this.editForm.smsOfflineAlarmEnable =
        row.smsOfflineAlarmEnable == 1 ? true : false;
      // this.editForm.smsLowPowerAlarmEnable =
      //   row.smsLowPowerAlarmEnable == 1 ? true : false;

	  this.editForm.projectId = String(row.projectId);
	 let param = { projectId: row.projectId };
      api
        .acquireData_getProjectAlarmContactorList_request(param)
        .then((res) => {
			let temp = [];
			if(res.data){
				let index = 0
				for (let i = 0; i < res.data.length; i++) {
					temp[index] = {id:parseInt(res.data[index].id),label:res.data[index].userNameCn};
					index++;
				}
			}
			this.alarmContactorList = temp;
			this.editForm.contactorIds = [];
			if(row.contactorList){
				let contactorIds = [];
				row.contactorList.forEach(one => {
					contactorIds.push(parseInt(one.id));
				});
				this.editForm.contactorIds = contactorIds;
			}
			this.editFormVisible = true;
        })
        .catch(function (e) {
          console.log(e);
          tools.error(new Vue(), e.message);
        });
	  
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    selectProjectChange(type,projectId) {
	   if(projectId == null || projectId == '') return;
	   this.treeMark = "two"
      let param = { projectId: projectId };
      api
        .acquireData_getProjectAlarmContactorList_request(param)
        .then((res) => {
			let temp = [];
			if(res.data){
				let index = 0
				for (let i = 0; i < res.data.length; i++) {
					temp[index] = {id:parseInt(res.data[index].id),label:res.data[index].userNameCn};
					index++;
				}
			}
			this.alarmContactorList = temp;
			if(type == 'edit') this.editForm.contactorIds =[];
			if(type == 'add') this.addForm.contactorIds =[];
        })
        .catch(function (e) {
          console.log(e);
          tools.error(new Vue(), e.message);
        });

    },
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editSubmitButtonDisabled = true;
          let param = Object.assign({}, this.editForm);
          if (this.editForm.contactorIds) {
            param.contactorIds = this.editForm.contactorIds.join(",");
          }
          param.smsAlarmEnable = this.editForm.smsAlarmEnable ? 1 : 0;
          param.smsEarlyAlarmEnable = this.editForm.smsEarlyAlarmEnable ? 1 : 0;
          param.smsOfflineAlarmEnable = this.editForm.smsOfflineAlarmEnable
            ? 1
            : 0;
          // param.smsLowPowerAlarmEnable = this.editForm.smsLowPowerAlarmEnable
          //   ? 1
          //   : 0;
          this.listLoading = true;
          let self = this;
          api
            .acquireData_saveOrUpdateWebhookSmsAlarmConfig_request(param)
            .then((res) => {
              this.editFormVisible = false;
              this.$refs.editForm.resetFields();
              this.editSubmitButtonDisabled = false;
              tools.success(this, "编辑成功");
              this.get_list_data();
            })
            .catch((e) => {
              console.log(e);
              self.editSubmitButtonDisabled = false;
			  self.listLoading = false;
              tools.error(new Vue(), e.message);
            });
          this.listLoading = false;
        }
      });
    },
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addSubmitButtonDisabled = true;
          let param = Object.assign({}, this.addForm);
          if (this.addForm.contactorIds) {
            param.contactorIds = this.addForm.contactorIds.join(",");
          }
          param.smsAlarmEnable = this.addForm.smsAlarmEnable ? 1 : 0;
          param.smsEarlyAlarmEnable = this.addForm.smsEarlyAlarmEnable ? 1 : 0;
          param.smsOfflineAlarmEnable = this.addForm.smsOfflineAlarmEnable
            ? 1
            : 0;
          // param.smsLowPowerAlarmEnable = this.addForm.smsLowPowerAlarmEnable
          //   ? 1
          //   : 0;
          this.listLoading = true;
          let self = this;
          api
            .acquireData_saveOrUpdateWebhookSmsAlarmConfig_request(param)
            .then((res) => {
              this.addFormVisible = false;
              this.$refs.addForm.resetFields();
              this.addSubmitButtonDisabled = false;
              tools.success(this, "新增成功");
              this.get_list_data();
            })
            .catch((e) => {
              console.log(e);
              self.addSubmitButtonDisabled = false;
			  self.listLoading = false;
              tools.error(new Vue(), e.message);
            });
          this.listLoading = false;
        }
      });
    },
    checkWebhookIsValid(webhook, from) {
      let param = { webhook: webhook };
      api
        .acquireData_checkWebhookIsValid_request(param)
        .then((res) => {
          //1:addform 2:editform
          if (from == 1) {
            this.$set(this.addForm, "webhookIsValid", res.data);
          } else {
            this.$set(this.editForm, "webhookIsValid", res.data);
          }
        })
        .catch(function (e) {
          console.log(e);
          tools.error(new Vue(), e.message);
        });
    },
	loadRootOptions(callback) {
		setTimeout(() => callback(null, this.alarmContactorList), 1000)
	},
  },
  mounted() {
    this.fetchPushModel();
    this.getProjectTree();
    this.get_list_data();
  },
};
</script>

<style lang="scss" scoped>
.push-container {
  margin-top: 20px;
  border: 1px solid #f3f3f3;
  .container-title {
    height: 30px;
    padding-left: 10px;
    padding-top: 10px;
    background: #f3f3f3;
  }
}
.status-message {
  display: inline;
  padding-right: 6px;
}
.error {
  color: red;
}
.success {
  color: blue;
}
</style>


// WEBPACK FOOTER //
// alarm_push_manage.vue?26f2226c